import { render, staticRenderFns } from "./DetailRinci.vue?vue&type=template&id=4b9c3204&scoped=true"
import script from "./DetailRinci.vue?vue&type=script&lang=js"
export * from "./DetailRinci.vue?vue&type=script&lang=js"
import style0 from "./DetailRinci.vue?vue&type=style&index=0&id=4b9c3204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c3204",
  null
  
)

export default component.exports